import { render, staticRenderFns } from "./BbsReplyContent.vue?vue&type=template&id=70fe8532&"
import script from "./BbsReplyContent.vue?vue&type=script&lang=js&"
export * from "./BbsReplyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/BbsReplyContent.vue"
export default component.exports